import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <React.Fragment>
      <div className="f-body">
        <span id="siteseal">
          <script
            async
            type="text/javascript"
            src="https://seal.godaddy.com/getSeal?sealID=ZH0XP4n4YVbRh6SDng1WjVb7KxKOhD5oXfZ5ICyYcMVlNGolVnJKMHD3Pw8R"
          ></script>
        </span>
        © 2019 All Plus NZ | Designed by Nathan Vo
      </div>
    </React.Fragment>
  );
};

export default Footer;
